<span
  (click)="isDialogOpen = !isDialogOpen"
  cdkOverlayOrigin
  #dialogTrigger="cdkOverlayOrigin"
  [class.--is-open]="isDialogOpen"
  data-test="more-button"
>
  More <capra-icon icon="icon-caret-down"></capra-icon>
</span>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="dialogTrigger"
  [cdkConnectedOverlayOpen]="isDialogOpen"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  (backdropClick)="isDialogOpen = !isDialogOpen"
>
  <ul class="overlay">
    <li (click)="hideOutputAndClose()" [class.disabled]="disableHideOutput" data-test="hide-output">Hide all output</li>
    <li [class.disabled]="!exportLink" data-test="export">
      <a download [href]="exportLink" target="_self" (click)="closeDialog()">Export</a>
    </li>
  </ul>
</ng-template>
